package top.wcpe.allincore.ui.web.preview

/** 异步加载 generation：仅最后一次发起的加载可提交，关闭后全部结果失效。 */
internal class PreviewLoadGeneration {
    private var sequence = 0L
    private var disposed = false

    fun next(): Long {
        check(!disposed) { "预览加载生命周期已关闭" }
        check(sequence < Long.MAX_VALUE) { "预览加载 generation 已耗尽" }
        sequence += 1L
        return sequence
    }

    fun isCurrent(generation: Long): Boolean = !disposed && generation == sequence

    fun dispose() {
        disposed = true
    }
}

/** 预览 session 的两阶段替换接缝，不负责创建候选资源。 */
internal class PreviewSessionLifecycle(private val clearAllTraces: () -> Unit) {
    private var sequence = 0L
    private var current: PreviewSessionResource? = null
    private var disposed = false

    val currentSessionId: Long?
        get() = current?.sessionId

    fun nextSessionId(): Long {
        check(!disposed) { "预览 session 生命周期已关闭" }
        check(sequence < Long.MAX_VALUE) { "预览 sessionId 已耗尽" }
        sequence += 1L
        return sequence
    }

    fun commit(candidate: PreviewSessionResource) {
        check(!disposed) { "预览 session 生命周期已关闭" }
        val previous = current
        previous?.freeze()
        try {
            candidate.activate()
        } catch (error: Throwable) {
            candidate.dispose()
            previous?.resume()
            throw error
        }
        current = candidate
        previous?.dispose()
    }

    fun dispose() {
        if (disposed) return
        disposed = true
        current?.freeze()
        current?.dispose()
        current = null
        clearAllTraces()
    }
}

internal class PreviewSessionResource(
    val sessionId: Long,
    private val onFreeze: () -> Unit,
    private val onActivate: () -> Unit,
    private val onDispose: () -> Unit,
    private val onResume: () -> Unit = {},
) {
    private var frozen = false
    private var activated = false
    private var disposed = false

    fun freeze() {
        if (frozen || disposed) return
        frozen = true
        onFreeze()
    }

    fun activate() {
        check(!disposed) { "候选预览 session 已关闭" }
        if (activated) return
        activated = true
        onActivate()
    }

    fun resume() {
        if (!frozen || disposed) return
        frozen = false
        onResume()
    }

    fun dispose() {
        if (disposed) return
        disposed = true
        onDispose()
    }
}
